import React, { useState } from "react";
import "./AlertPercentage.css";
import { TiDelete } from "react-icons/ti";
import { getCommercializerCommissionNotice } from "../../utils/commercializerCommissionNotice";

const AlertPercentage = ({ commercializer }) => {
  const commissionLines = getCommercializerCommissionNotice(commercializer);
  const [AlertPercentage, setAlertPercentage] = useState(true);

  const CloseAlert = () => {
    setAlertPercentage(false);
  };

  return (
    <>
      {AlertPercentage === true ? (
        <div className="boxalertpercentage">
          <p className="textalertpercentage">
            <strong>A PARTIR DE LA VENTA DE OCTUBRE</strong>
            <br />
            <br />
            Estimado comercializador,
            <br />
            <br />
            Le informamos que, debido a los recientes aumentos en los créditos,
            las escalas de comisiones han sido ajustadas. Estas comisiones están
            indexadas al Salario Mínimo, Vital y Móvil, tal como lo establece el
            anexo correspondiente.
            <br />
            <br />
            Nuevas escalas:
            <br />
            <br />
            {commissionLines.map((line, index) => (
              <React.Fragment key={line}>
                {index > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
            <br />
            <br />
            Agradecemos su comprensión y colaboración.
            <br />
            <br />
            Atentamente,
            <br />
            Amebo
          </p>
          <TiDelete className="iconalertpercentage" onClick={CloseAlert} />
        </div>
      ) : null}
    </>
  );
};

export default AlertPercentage;
